import VueMask from '@devindex/vue-mask';
import { autoAnimatePlugin } from '@formkit/auto-animate/vue';
import { VueQueryPlugin } from '@tanstack/vue-query';
import type { App } from 'vue';

import { StuutUI } from '@stuut/ui';

import pinia from './pinia';
import PosthogPlugin from './posthog-plugin';

export const usePlugins = {
  install: (app: App) => {
    app.use(autoAnimatePlugin);
    app.use(pinia);
    app.use(VueMask);
    app.use(VueQueryPlugin);
    app.use(StuutUI);
    app.use(PosthogPlugin);
  },
};

export default usePlugins;
